

import Parse from '../../parseConfig';

import { validateUserSession } from './validateUserSession';


export const fetchPlanData = async () => {

  try {

    const isValid = await validateUserSession();

    if (!isValid) {
      throw new Error('Invalid user session');
    }
    else {
      //console.log('FetchPlanData: Valid user session');
    }

    const currentUser = Parse.User.current();

    if (!currentUser) {
      throw new Error('No user is currently logged in.');
    }


    // Step 1: Get the "Overlay" file type
    const FileType = Parse.Object.extend('FileType');
    const fileTypeQuery = new Parse.Query(FileType);
    fileTypeQuery.equalTo('name', 'Overlay');
    const overlayType = await fileTypeQuery.first();

    if (!overlayType) {
      console.warn('Overlay file type not found');
      return {};
    }


    // Step 2: Query PlanFile where fileType is "Overlay"
    const PlanFile = Parse.Object.extend('PlanFile');
    const planFileQuery = new Parse.Query(PlanFile);
    planFileQuery.equalTo('fileType', overlayType);
    planFileQuery.include('plan');
    planFileQuery.include('plan.series');

    const isPublicUser = currentUser.get('isMemberOfPublic') === 1;

    // Only include plans visible to the public if the user is a public user. This includes our "Guest" user.
    if (isPublicUser) {  // Filter out hidden plans by adding a subquery on the 'plan' relation
      const Plan = Parse.Object.extend('Plan');
      const visiblePlansQuery = new Parse.Query(Plan);
      visiblePlansQuery.notEqualTo('hideFromPublic', 1);
      planFileQuery.matchesQuery('plan', visiblePlansQuery);
    }

    const planFiles = await planFileQuery.find();

    // Step 3: Build grouped dictionary
    const plansBySeries = {};

    planFiles.forEach(planFile => {

      const plan = planFile.get('plan');
      if (!plan) return;

      const series = plan.get('series');

      if (!series) {
        console.log('Plan with no series:', plan.get('name'), plan.id);
      }

      const seriesName = series?.get('name') || 'Unnamed Series';

      if (!plansBySeries[seriesName]) {
        plansBySeries[seriesName] = [];
      }

      // Attach the planFile object for later use (e.g., overlay access)
      plan.set('planFile', planFile);

      plansBySeries[seriesName].push(plan);
    });

    // Step 3A - sort each series by Plan size (ascending)
    Object.keys(plansBySeries).forEach(seriesName => {
      plansBySeries[seriesName].sort((a, b) => {
        const sizeA = a.get('size') ?? 0;
        const sizeB = b.get('size') ?? 0;
        return sizeA - sizeB;
      });
    });


    // Step 4: Add Accessory overlays as before
    const AccessoryOverlay = Parse.Object.extend('AccessoryOverlay');
    const accessoryQuery = new Parse.Query(AccessoryOverlay);
    accessoryQuery.ascending('size');
    const accessoryResults = await accessoryQuery.find();

    plansBySeries['Accessory'] = accessoryResults;

    return plansBySeries;

  } catch (error) {
    console.error('Error fetching plans and overlays:', error);
    return {};
  }
};